import { OccConfig } from "@spartacus/core";

export const customDefaultOccOrderDetailsConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        orderDetail: 'users/${userId}/abstractorders/${orderId}?fields=FULL',
      }
    }
  }
}